import { createFileRoute } from "@tanstack/react-router";
import { PageShell, PageHero } from "@/components/PageShell";
import { PhysioBotPanel } from "@/components/PhysioBot";

export const Route = createFileRoute("/symptom-guide")({
  component: () => (
    <PageShell>
      <PageHero eyebrow="Physio Bot" title="Tell us what's bothering you" subtitle="Chat with Physio Bot about your pain or injury, learn how physiotherapy can help, and find the right appointment." />
      <section className="container-page py-10 max-w-2xl">
        <PhysioBotPanel className="h-[min(560px,calc(100dvh-10rem))] min-h-[300px]" />
      </section>
    </PageShell>
  ),
  head: () => ({
    meta: [
      { title: "Physio Bot, N S Physiotherapy" },
      { name: "description", content: "Chat with Physio Bot about your pain or injury and book with N S Physiotherapy in Centurion." },
      { property: "og:title", content: "Physio Bot, N S Physiotherapy" },
      { property: "og:description", content: "Describe your symptoms, get guidance and find the right physiotherapy service." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
    links: [{ rel: "canonical", href: "/symptom-guide" }],
  }),
});
